import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AlertBoxComponent } from './shared/alertbox.component';
import { HeaderComponent } from './shared/header.component';
import { HeaderLoginComponent } from './shared/headerLogin.component';
import { MenudesktopComponent } from './shared/menudesktop.component';
import { MenumobileComponent } from './shared/menumobile.component';

import { CookieLawModule } from './shared/cookie-law/cookie-law.module';

import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { NgChartsModule } from 'ng2-charts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CalendarModule } from 'primeng/calendar';
import { SacyrInputComponent } from './shared/sacyr-input/sacyr-input.component';
import { SacyrDataTableModule } from './shared/sacyr-data-table/sacyr-data-table.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SacyrModalModule } from './shared/sacyr-modal/sacyr-modal.module';
// import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';

// import { SidebarModule } from 'ng-sidebar'; // Not compatible with Ivy
// import { PrimeNGConfig } from 'primeng/api'; // Not compatible with Ivy
// import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner'; // Deprecated
// import { DataTableModule } from 'angular2-datatable'; // Deprecated

@NgModule({
  declarations: [
    AlertBoxComponent,
    HeaderComponent,
    HeaderLoginComponent,
    MenudesktopComponent,
    MenumobileComponent,
    SacyrInputComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NgxSpinnerModule,
    NgChartsModule,
    NgxDatatableModule,
    SacyrModalModule,
    CalendarModule,
    CookieLawModule,
    SacyrDataTableModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NgChartsModule,
    NgxDatatableModule,
    NgxSpinnerModule,
    SacyrModalModule,
    CookieLawModule,
    AlertBoxComponent,
    HeaderComponent,
    HeaderLoginComponent,
    MenudesktopComponent,
    MenumobileComponent,
    CalendarModule,
    SacyrInputComponent,
    SacyrDataTableModule,
  ]
})
export class SharedModule { }